import React from 'react';
import TbodyTableContrato from './tbody';
import TheadTableContrato from './thead';
const TableContrato = (props) => {
  const { loadingTables } = props.data;
  return (
    <div className="overflow-x-auto">
      {!loadingTables && (
        <table className="w-full table-auto text-sm">
          <TheadTableContrato />
          <TbodyTableContrato
            actions={props.actions}
            endPoint={props.endPoint}
          />
        </table>
      )}
    </div>
  );
};
export default TableContrato;
